<template>
  <div class="pr-footer">
    <el-footer class="p-0" height="132px">
      <div class="pr-f-top pr-container py-5 flex-between">
        <div><i class="el-icon-location-information font16"></i> 地址：深圳市罗湖区莲塘国威路68号智美国威电子商务大厦1313房</div>
        <div><i class="el-icon-collection-tag font16"></i> 邮编：518061</div>
        <div><i class="el-icon-phone-outline font16"></i> 电话：18682099502</div>
        <div><i class="el-icon-message font16"></i> 邮箱：wang.yuyu@szpuree.com</div>
      </div>
      <div class="py-2" style="background:#fff;">
        <div class="pr-container col999 font12 text-right">
          <span>深圳市蒲睿科技有限公司</span>
          <span class="ml-3">版权所有</span>
          <span class="ml-3">
            <router-link to="" @click.native="toPage">粤ICP备2024232449号</router-link>
          </span>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      
    }
  },
  created() {
    
  },
  computed: {

  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    toPage() {
      window.open('http://beian.miit.gov.cn')
    }
  }
}
</script>

<style lang="scss">
.pr-footer {
  background: #213752;
  .pr-f-top {
    color: rgba($color: #ffffff, $alpha: .4);
  }
}
</style>

